export default __webpack_public_path__ + "static/media/AE-AZ.22bf4025.png";